/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 * @Date: 2020-12-24 19:30:59
 * @LastEditTime: 2020-12-24 19:54:21
 */
const state = {
  pageText: {}
}
export default state
